module.exports = __webpack_public_path__ + "static/media/BannerRigth.aa56daf2.svg";